const features = [
  {
    icon: 'ri-scan-2-line',
    title: 'Advanced Digital Imaging',
    desc: '3D scans and digital X-rays provide a complete, precise picture of your smile before treatment begins.',
  },
  {
    icon: 'ri-slideshow-3-line',
    title: 'Custom Treatment Planning',
    desc: 'Every plan is engineered around your unique anatomy — precise, purposeful, and built to last.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Patient-First Experience',
    desc: 'From appointment flexibility to chair comfort, every detail is crafted to put you at ease.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Predictable, On-Time Results',
    desc: 'Modern systems deliver consistent timelines so you reach your goal with clarity and confidence.',
  },
];

export default function TechnologySection() {
  return (
    <section id="technology" className="bg-[#F9F8F5] py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">

          {/* RIGHT — premium image */}
          <div className="relative order-1 lg:order-2">
            <div className="relative h-[480px] md:h-[580px] rounded-[28px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/7ae3dc7c9e8889bba66665868be6a72d.jpg"
                alt="Advanced orthodontic technology at Smile By Dr. K Chatsworth CA"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#1C3528]/25" />
            </div>

            {/* Gold accent bar */}
            <div className="absolute top-14 -right-2 w-1.5 h-24 bg-gradient-to-b from-[#C4A96E] to-[#C4A96E]/20 rounded-full" />

            {/* Stats card */}
            <div className="absolute bottom-10 -left-4 md:-left-8 bg-[#1C3528] rounded-2xl px-6 py-5">
              <div className="flex gap-7">
                {[
                  { value: 'Phase I & II', sub: 'Expert Care' },
                  { value: 'All Ages', sub: 'Welcome' },
                ].map((s) => (
                  <div key={s.sub} className="text-center">
                    <p
                      className="text-white font-semibold leading-tight mb-1"
                      style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '17px' }}
                    >
                      {s.value}
                    </p>
                    <p
                      className="text-[#C4A96E] text-[9px] tracking-[0.2em] uppercase font-semibold"
                      style={{ fontFamily: 'DM Sans, sans-serif' }}
                    >
                      {s.sub}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Dot grid */}
            <div className="absolute -top-3 -left-3 w-20 h-20 grid grid-cols-4 gap-1.5 opacity-20">
              {Array.from({ length: 16 }).map((_, i) => (
                <div key={i} className="w-1 h-1 rounded-full bg-[#4C8265]" />
              ))}
            </div>
          </div>

          {/* LEFT — content */}
          <div className="order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-7">
              <span className="w-8 h-px bg-[#C4A96E]" />
              <span
                className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Modern Orthodontics
              </span>
            </div>

            <h2
              className="text-[42px] md:text-[54px] text-[#1A2118] font-semibold leading-[1.06] mb-6"
              style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
            >
              Precision Technology,<br />
              <span className="font-light italic text-[#4C8265]">Compassionate Care</span>
            </h2>

            <p
              className="text-[#5A7060] text-base leading-[1.9] mb-10"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              We invest in the latest orthodontic advances so that your experience is smoother, your results are more predictable, and your treatment feels truly personal — from first imaging to final smile reveal.
            </p>

            {/* Features */}
            <div className="flex flex-col gap-6">
              {features.map((f) => (
                <div key={f.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#EBF5EF] rounded-xl flex-shrink-0 mt-0.5">
                    <i className={`${f.icon} text-[#4C8265] text-lg`} />
                  </div>
                  <div>
                    <p
                      className="text-[#1A2118] font-semibold text-sm mb-1.5"
                      style={{ fontFamily: 'DM Sans, sans-serif' }}
                    >
                      {f.title}
                    </p>
                    <p
                      className="text-[#5A7060] text-xs leading-relaxed"
                      style={{ fontFamily: 'DM Sans, sans-serif' }}
                    >
                      {f.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
